import React from "react";
import { styled } from "styled-components";
import { Table } from "components/bootstrap";
import DefaultColumnRenderers from "components/common/EntityDataTable/DefaultColumnRenderers";
const TD = styled.td`
  white-space: nowrap;
`;
const EventDetailsTable = ({
  event,
  attributesList,
  meta = {},
  eventProcedureId = "",
  attributesRenderers
}) => /* @__PURE__ */ React.createElement(Table, { condensed: true, striped: true }, /* @__PURE__ */ React.createElement("tbody", null, attributesList.map((attribute) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const defaultTypeRenderer = (_b = (_a = DefaultColumnRenderers.types) == null ? void 0 : _a[attribute == null ? void 0 : attribute.type]) == null ? void 0 : _b.renderCell;
  const typeRenderer = (_d = (_c = attributesRenderers == null ? void 0 : attributesRenderers.types) == null ? void 0 : _c[attribute == null ? void 0 : attribute.type]) == null ? void 0 : _d.renderCell;
  const renderCell = (_g = (_f = (_e = attributesRenderers[attribute.id]) == null ? void 0 : _e.renderCell) != null ? _f : typeRenderer) != null ? _g : defaultTypeRenderer;
  const value = event[attribute.id];
  return /* @__PURE__ */ React.createElement("tr", { key: attribute.id }, attribute.title && /* @__PURE__ */ React.createElement(TD, null, /* @__PURE__ */ React.createElement("b", null, attribute.title)), /* @__PURE__ */ React.createElement("td", null, renderCell ? renderCell(value, event, meta, eventProcedureId) : value));
})));
export default EventDetailsTable;
